import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load pages
const PurchaseOrderList = lazy(() => import('./pages/PurchaseOrderList'));
const PurchaseOrderCreate = lazy(() => import('./pages/PurchaseOrderCreate'));
const PurchaseOrderEdit = lazy(() => import('./pages/PurchaseOrderEdit'));
const PurchaseOrderView = lazy(() => import('./pages/PurchaseOrderView'));

const purchaseRoutes: RouteObject[] = [
  {
    index: true,
    element: <PurchaseOrderList />,
  },
  {
    path: 'orders',
    element: <PurchaseOrderList />,
  },
  {
    path: 'orders/create',
    element: <PurchaseOrderCreate />,
  },
  {
    path: 'orders/:id',
    element: <PurchaseOrderView />,
  },
  {
    path: 'orders/:id/edit',
    element: <PurchaseOrderEdit />,
  },
];

export default purchaseRoutes;
